import { normaliseerZoektekst } from "./zoekNormalisatie";

/**
 * Snelzoeker-matcher (D8, overleg Martine 02-09-2026): de zoekterm wordt op
 * witruimte gesplitst en élk token moet ergens in "naam kenmerk" voorkomen,
 * zodat "berg 010126" of "HLRV ber" het dossier vindt. Bewust simpel en snel:
 * geen fuzzy matching. Sinds 1-11-2026 wel dezelfde normalisatie als de
 * lijsten (zoekNormalisatie): accenten en leestekens tellen niet mee, zodat
 * "muller" ook "Müller" vindt.
 */
export function matchtZoekterm(
  naam: string,
  kenmerk: string,
  term: string,
): boolean {
  const tokens = normaliseerZoektekst(term).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return false;
  const doel = normaliseerZoektekst(`${naam} ${kenmerk}`);
  return tokens.every((token) => doel.includes(token));
}
